import { media } from '@amx/ux-twoui';
import type { IStyle } from '@fluentui/react';
import { MAX_WIDTH } from '../../shared/constants';

export interface ILayoutStyles {
  pageContent: IStyle;
  heading: IStyle;
  content: IStyle;
  mobileContent: IStyle;
  leftNav: IStyle;
}

export const layoutStyles: ILayoutStyles = {
  leftNav: {
    marginTop: '8px',
    [media.maxL]: {
      marginTop: '0',
    },
  },
  pageContent: {
    width: '100%',
  },
  heading: {
    paddingLeft: '10px',
    marginTop: '5px',
  },
  content: {
    maxWidth: `${MAX_WIDTH}px`,
    width: '100%',
  },
  mobileContent: {
    padding: '0 16px',
    display: 'flex',
    flexFlow: 'column',
  },
};
